//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Static Guids used by the Rock application */
export const NoteType = {
    /** Generic prayer comment note type */
    BenevolenceRequestNote: "CC49BF39-8D3E-4512-B8F4-853FE49CDBC7",
    /** The content channel item structured content user value */
    ContentChannelItemStructuredContentUserValue: "860C37A0-1A44-4681-B96D-4703813609D2",
    /** The fundraising opportunity comment */
    FundraisingOpportunityComment: "9BB1A7B6-0E51-4E0E-BFC0-1E42F4F2DA95",
    /** Group Member Note */
    GroupmemberNote: "FFFC3644-60CD-4D14-A714-E8DCC202A0E1",
    /** The pastoral note type. */
    PastoralNote: "5B7BE8F4-481B-4BA3-99A2-B26307A2BA42",
    /** The Note to display the errors particular to the profile that occurred while importing the people CSV. */
    PersonCsvImportErrorNote: "4E22E9DA-06A7-45DB-9EB3-BFCB7A2A7F21",
    /** Person event registration */
    PersonEventRegistration: "BBADA8EF-23FC-4B46-B7A7-0F6D31F8C045",
    /** Person note */
    PersonTimelineNote: "66A1B9D7-7EFA-40F3-9415-E54437977D60",
    /** Generic prayer comment note type */
    PrayerComment: "0EBABD75-0890-4756-A9EE-62626282BB5D",
    /** Generic scheduled transaction note type */
    ScheduledTransactionNote: "360CFFE2-7FE3-4B0B-85A7-BFDACC9AF588",
    /** The workflow change log note */
    WorkflowChangeLogNote: "A297E854-5FAC-4A9E-9F77-F58F4D52B5A6",
    /** Generic workflow note type */
    WorkflowNote: "A6CE445C-3B49-4401-82E6-312BF7946A6B",
};
